<div class="brand-settings" *ngIf="brand">
  <app-brand-user-management class="brand-settings-item" [brand]="brand" />
  <app-brand-upload-logo class="brand-settings-item" [brand]="brand" />
</div>
